import { FixedPageHeader } from 'Components/Layout';
import { useSelector } from 'react-redux';
import { WorksheetBatchUpdateConfigurationDialogButton } from '../WorksheetBatchUpdateConfigurationDialog';

interface IFixedWorksheetBatchUpdateHeaderProps {
  pageIdentifier: string;
}

const FixedWorksheetBatchUpdateHeader: React.FC<IFixedWorksheetBatchUpdateHeaderProps> = ({ pageIdentifier }) => {
  const saving = useSelector(
    (state) => state.worksheetBatchUpdate.status.applyingUpdate || state.worksheetBatchUpdate.status.checking
  );
  const worksheetsLoaded = useSelector(
    (state) => state.worksheetBatchUpdate.worksheets && Object.values(state.worksheetBatchUpdate.worksheets).length > 0
  );

  return (
    <FixedPageHeader
      pageIdentifier={pageIdentifier}
      pageStatus={saving ? 'Saving...' : worksheetsLoaded ? 'Saved' : ''}
      pageProcessing={saving}
      pageAdditionalAction={<WorksheetBatchUpdateConfigurationDialogButton />}
    />
  );
};

export default FixedWorksheetBatchUpdateHeader;
